import { useEffect } from 'react';
import type { Session } from '@asi-lda/pnet-auth-web';
import { usePnetAuth } from '@asi-lda/pnet-auth-web/react';

/**
 * The kit's Session for code outside React (ApiProvider's logout). Set by
 * <SessionRegistry/> rendered inside <PnetAuthProvider>.
 */
let current: Session | null = null;

export const getAuthSession = (): Session | null => current;

export const SessionRegistry = () => {
  const { session } = usePnetAuth();
  current = session;
  useEffect(() => {
    current = session;
  }, [session]);
  return null;
};
